export default __webpack_public_path__ + "static/birds-715a16f43c26396738059fcfca53f5ab.svg";